<template>
  <div class="site-content">
    <!-- GLive Page Header  -->
    <div class="page-header bg-2">
      <div class="overlay-section low-op">
        <!-- GLive Top Ad 970 x 195 -->
        <div class="rectangle-ad-wrapper-other">
          <img
            src="/static/img/ads/970X250-ad.png"
            width="970"
            height="250"
            alt
            class="img-responsive-other"
          >
        </div>
        <div class="container page-header-section">
          <h1>Gallery</h1>
        </div>
      </div>
    </div>

    <!-- GLive Events Gallery -->
    <div class="gallery-wrapper">
      <div class="container photo-gallery">
        <div class="row">
          <div
            class="col-md-4 col-sm-6 col-xs-12 gallery-item-wrapper"
            v-for="category in categories"
            :key="category.id"
          >
            <div class="gallery-item">
              <router-link :to="{path: '/gallery/' + category.path}">
                <a
                  rel="bookmark"
                  :title="category.title"
                >
                  <img
                    :src="image_path+category.url_thumb"
                    alt
                    class="img-responsive"
                  >
                </a>
                <div class="gallery-caption">
                  <span>{{category.title}}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      image_path: "https://show.guyanalive.com/",
      categories: [],
      errors: []
    };
  },

  // Fetches posts when the component is created.
  created() {
    window.scrollTo(0, 0);
    this.getCategories();
  },
  methods: {
    getCategories() {
      axios
        .get("https://show.guyanalive.com/index.php?json")
        .then(response => {
          // JSON responses are automatically parsed.
          this.categories = response.data.gallery.albums;
          // hide flyers
          var flyerIndex = this.categories.findIndex(x => x.path === "Flyers");
          this.categories.splice(flyerIndex);
        })
        .catch(e => {
          this.errors.push(e);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gallery/GalleryPage.vue